module.exports = __webpack_public_path__ + "static/01-b0de448916acf9833007452babaaa1c1.jpg";